var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransactionsBackIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#EBEEF7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2563 19.0425C15.2174 19.0035 15.2173 18.9403 15.2563 18.9012L20.8262 13.3201C21.1188 13.0269 21.1184 12.5521 20.8252 12.2595C20.532 11.9669 20.0571 11.9673 19.7645 12.2605L13.5951 18.4423C13.3025 18.7355 13.3029 19.2104 13.5961 19.503C13.5974 19.5043 13.5986 19.5055 13.5999 19.5067L19.7648 25.6785C20.0575 25.9715 20.5324 25.9718 20.8254 25.6791C21.1185 25.3863 21.1188 24.9115 20.826 24.6184L15.2563 19.0425Z",
    fill: "#363941"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionsBackIcon);
export default __webpack_public_path__ + "static/media/transactions-back-icon.3bd61c8cbd3595098abbcc31525b127a.svg";
export { ForwardRef as ReactComponent };